import { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';

import { CustomNavbar } from "components/Navbars/CustomNavbar";
import { Sidebar } from 'components/Sidebar/Sidebar';
import { LinearLoading } from 'common/Loading/LinearLoading';

//Se hace la importacion y se asigna un "Alias"
import * as routes from 'routes/index.js'

const drawerWidth = 240;

// Funcion que prepara un array con todas las rutas de la App
const prepareArrayRoutes = () => {
    let array = []

    Object.entries(routes).forEach(([prop, route]) => {

        route.map((item, key) =>{
            // console.log(item)
            // Si el Item no tiene subrutas, entonces prepara directo
            if ( item.subRoutes.length === 0 ){
                array.push(item)
            }else{
                item.subRoutes.map((subItem, subKey) => (
                    array.push(subItem)
                ));
            }
        })

    })

    return array
}

// Array que contendrá las rutas una vez procesadas para utilizar un map
const routes_array = prepareArrayRoutes();

export const AdminLayout = (props) => {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <CustomNavbar 
                routes={routes}
                window={window}
                mobileOpen={mobileOpen}
                setMobileOpen={setMobileOpen}
                isClosing={isClosing}
                setIsClosing={setIsClosing}
                handleDrawerClose={handleDrawerClose}
                handleDrawerTransitionEnd={handleDrawerTransitionEnd}
                handleDrawerToggle={handleDrawerToggle}
            />
            <Sidebar 
                routes={routes}
                window={window}
                mobileOpen={mobileOpen}
                setMobileOpen={setMobileOpen}
                isClosing={isClosing}
                setIsClosing={setIsClosing}
                handleDrawerClose={handleDrawerClose}
                handleDrawerTransitionEnd={handleDrawerTransitionEnd}
                handleDrawerToggle={handleDrawerToggle}
            />
            
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
                style={{background: '#f4f3ef', color: '#eeeeed'}}
            >
                <Toolbar />
                <Suspense fallback={<LinearLoading />}>
                    <Routes>
                        {
                            routes_array.map((item, key) => {
                                return (
                                    <Route
                                        path={item.path}
                                        element={item.component}
                                        key={key}
                                        exact
                                    />
                                )
                            })
                        }
                        <Route path="/" element={<Navigate to="/inicio" />} />
                        <Route path="/*" element={<Navigate to="/inicio" />} />
                    </Routes>
                </Suspense>
            </Box>
        </Box>
    );
}

AdminLayout.propTypes = {
    window: PropTypes.func,
};

